// Показателите на „Натовареност" — върху ПОКАЗАНИТЕ редове, както в
// „Продажби по периоди" (търсачката стеснява и кутийките, и графиката).

import { useTranslation } from "react-i18next";

import { formatNumber } from "../../../../components/dataTable";
import type { SalesByPeriodsUnit } from "../../../../api/reportsSalesByPeriods";
import { ReportKpiCard } from "../ReportKpiCard";
import { noShowRate } from "./reservationReportFormat";
import type { OccupancyTotals } from "./occupancyMath";

type Props = {
  totals: OccupancyTotals;
  unit: SalesByPeriodsUnit;
  isNarrow: boolean;
};

export const OccupancyKpis = ({ totals, unit, isNarrow }: Props) => {
  const { t } = useTranslation();
  const noShow = noShowRate(totals);

  return (
    <div
      className={`grid gap-2.5 ${
        isNarrow ? "grid-cols-2" : "grid-cols-2 lg:grid-cols-5"
      }`}
    >
      <ReportKpiCard
        kicker={t("reportsPage.rvKpiReservations")}
        value={String(totals.reservations)}
        sub={t("reportsPage.rvKpiReservationsSub", {
          upcoming: totals.upcoming,
          seated: totals.seated,
        })}
        hero
      />
      <ReportKpiCard
        kicker={t("reportsPage.rvKpiGuests")}
        value={String(totals.guests)}
        sub={t("reportsPage.rvKpiGuestsSub")}
      />
      <ReportKpiCard
        kicker={t("reportsPage.rvKpiPerPeriod", {
          unit: t(`reportsPage.rvPerUnit_${unit}`),
        })}
        value={totals.perRow === null ? "—" : formatNumber(totals.perRow, 1)}
        sub={t("reportsPage.rvKpiPerPeriodSub", { count: totals.rows })}
      />
      <ReportKpiCard
        kicker={t("reportsPage.rvStatus_completed")}
        value={String(totals.completed)}
        sub={t("reportsPage.rvKpiCompletedSub")}
      />
      <ReportKpiCard
        kicker={t("reportsPage.rvStatus_expired")}
        value={String(totals.expired)}
        sub={
          noShow === null
            ? t("reportsPage.rvKpiNoShowNone")
            : t("reportsPage.rvKpiNoShowRate", { value: formatNumber(noShow, 1) })
        }
        hot={totals.expired > 0}
      />
    </div>
  );
};
